import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { connect } from "react-redux";

import "../styles/color-donut.css";

import { Doughnut } from "react-chartjs-2";

import {
  updateVariantAction,
  updateColorAction,
  updateWheelAction,
  updateRareUpperSpoiler,
  updateRareUnderSpoiler,
  updateSideSpoiler,
  updateFrontSpoiler,
  updateOtherOptions,
  updateSpoilers,
  updateBumperAction,
} from "../redux/carState.reducer";

import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Iframe from "react-iframe";

const BottomNavigationComponent = (props) => {
  const { config, carName } = props;
  // const { config } = useSelector((state) => state.config);
  const { carState } = useSelector((state) => state);

  const [variants, setVariants] = useState([]);
  const [colors, setColors] = useState([]);
  const [wheels, setWheels] = useState([]);
  const [otherOptions, setOtherOptions] = useState([]);
  const [spoilers, setSpoilers] = useState([]);
  const [bumpers, setBumpers] = useState([]);

  const [rareUpperSpoiler, setRareUpperSpoiler] = useState(false);
  const [rareUnderSpoiler, setRareUnderSpoiler] = useState(false);
  const [sideSpoiler, setSideSpoiler] = useState(false);
  const [frontSpoiler, setFrontSpoiler] = useState(false);

  const [cWheel, setCWheel] = useState({});
  const [cVariant, setCVariant] = useState({});
  const [cColor, setCColor] = useState({});
  const [cOther, setCOther] = useState({});
  const [cSpoiler, setCSpoiler] = useState({});
  const [cBumper, setCBumper] = useState({});

  const [isAllOtherOptionSelected, setIsAllOtherOptionSelected] = useState(
    false
  );

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [donutData, setDonutData] = useState({});
  const [donutBumperData, setDonutBumperData] = useState({});
  // console.log(carState)
  useEffect(() => {
    if (!!config && !!config.variants) {
      setVariants(config.variants);
    }
    if (!!config && !!config.colors) {
      configColorDonut(config.colors);
    }
    if (!!config && !!config.wheels) {
      setWheels(config.wheels);
    }
    if (!!config && !!config.otherOptions) {
      setOtherOptions(config.otherOptions);
    }
    if (!!config && !!config.spoilers) {
      setSpoilers(config.spoilers);
    }
    if (!!config && !!config.bumpers) {
      configColorBumperDonut(config.bumpers);
    }
  }, [config]);

  useEffect(() => {
    if (!!carState) {
      if (!!carState.variant) {
        setCVariant(carState.variant);
      }
      if (!!carState.color) {
        setCColor(carState.color);
      }
      if (!!carState.wheel) {
        setCWheel(carState.wheel);
      }
      if (!!carState.otherOptions) {
        setCOther(carState.otherOptions);
      }
      if (!!carState.bumpers) {
        setCBumper(carState.bumpers);
      }

      setRareUpperSpoiler(carState.rareUpperSpoiler);
      setRareUnderSpoiler(carState.rareUnderSpoiler);
      setFrontSpoiler(carState.frontSpoiler);
      setSideSpoiler(carState.sideSpoiler);
    }
  }, [carState]);

  const configColorDonut = (colors) => {
    setColors(colors);
    const donutData = {};
    const datasets = {};

    datasets.backgroundColor = colors.map((d) => d.colorHash);
    datasets.data = [...Array(colors.length)].map(
      (e, index) => 360 / colors.length
    );

    donutData.labels = colors.map((d) => d.name);
    donutData.datasets = new Array(datasets);

    setDonutData(donutData);
  };

  const configColorBumperDonut = (bumpers) => {
    setBumpers(bumpers);
    const donutBumperData = {};
    const datasets = {};

    datasets.backgroundColor = bumpers.map((d) => d.colorHash);
    datasets.data = [...Array(bumpers.length)].map(
      (e, index) => 360 / bumpers.length
    );
    donutBumperData.colorCode = bumpers.map((d) => d.colorCode);
    donutBumperData.labels = bumpers.map((d) => d.name);
    donutBumperData.datasets = new Array(datasets);

    setDonutBumperData(donutBumperData);
  };

  const updateOtherOptions = (op) => {
    if (!!cOther[op.name]) {
      delete cOther[op.name];
    } else {
      cOther[op.name] = op;
    }

    props.updateOtherOptions(cOther);
  };

  const isOptionActive = (name) => {
    return !!cOther[name];
  };

  const isSpoilerActive = (name) => {
    return !!cSpoiler[name];
  };

  const updateSpoilers = (op) => {
    if (!!cSpoiler[op.name]) {
      delete cSpoiler[op.name];
    } else {
      cSpoiler[op.name] = op;
    }

    props.updateSpoilers(cSpoiler);
  };

  const isBumperActive = (name) => {
    return !!cBumper[name];
  };

  const applyCarColorByIndex = (idx) => {
    props.updateColorAction(colors[idx]);
  };

  const renderColorDonut = (donutData) => {
    return (
      <>
        <Doughnut
          data={donutData}
          options={{
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index];
                },
              },
            },
            responsive: true,
            maintainAspectRatio: true,
            onClick: (event, elements) => {
              const chart = elements[0]._chart;
              const element = chart.getElementAtEvent(event)[0];
              const dataset = chart.data.datasets[element._datasetIndex];
              const xLabel = chart.data.labels[element._index];
              const value = dataset.data[element._index];

              applyCarColorByIndex(element._index);
            },
          }}
        />
      </>
    );
  };

  const applyCarColorBumperByIndex = (idx) => {
    props.updateBumperAction(bumpers[idx]);
  };

  const renderColorBumperDonut = (donutBumperData) => {
    return (
      <>
        <Doughnut
          data={donutBumperData}
          options={{
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  // return data.labels[tooltipItem.index];
                  return data.colorCode[tooltipItem.index];
                },
              },
            },
            responsive: true,
            maintainAspectRatio: true,
            onClick: (event, elements) => {
              const chart = elements[0]._chart;
              const element = chart.getElementAtEvent(event)[0];
              const dataset = chart.data.datasets[element._datasetIndex];
              const xLabel = chart.data.labels[element._index];
              const value = dataset.data[element._index];
              applyCarColorBumperByIndex(element._index);
            },
          }}
        />
      </>
    );
  };
    {/* <li className = "w-full" >
      <button className="h-12 px-3 md:px-10 md:rounded text-white bg-black bg-opacity-75 hover:bg-opacity-100 transition ease-in-out duration-300">
        Exterior
      </button>
    </li > */}
  return (
    <nav className = "absolute z-20 w-full inset-x-0 bottom-0 -mb-16 md:mb-8 md:mb-32 md:flex md:items-center md:justify-center" >
      <Modal
        id="interior-modal"
        show={show}
        onHide={handleClose}
        size="xl"
        style={{ zIndex: "9999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Interior</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Iframe
            src={`/360/${carName}`}
            width="100%"
            height="600px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal.Body>
      </Modal>
      <ul className="flex space-x-px md:space-x-4 items-center filter blur-lg bg-gray-100 bg-opacity-50 md:px-5 md:py-4 rounded-xl md:border border-gray-400">

        <li className="w-full">
          <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
            Car Type
          </a>
          <div className="sub-menu body-type">
            <ul>
              {!!variants.length &&
                variants.map((d, i) => (
                  <li
                    key={i}
                    onClick={(e) => {
                      props.updateVariantAction(d);
                      // console.log(d.defaultWheelType);
                      d.defaultWheelType &&
                        props.updateWheelAction(d.defaultWheelType);
                    }}
                  >
                    <a href="#" className={cVariant.name === d.name ? 'selected-text' : ''} key={i}>{d.name}</a>
                  </li>
                ))}
            </ul>
          </div>
        </li>
        <li className="color-menu w-full">
          <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
            Spray
          </a>
          <div
            className="sub-menu"
            style={{
              height: "150px",
              width: "274px",
              top: "-150px",
              left: "-112px",
              background: "none",
            }}
          >
            {renderColorDonut(donutData)}
          </div>
        </li>
        {/* <li className="color-menu w-full">
          <a className="h-12 md:rounded text-white w-full md:w-12" href="#">
            Bumper
          </a>
          <div
            className="sub-menu"
            style={{
              height: "150px",
              width: "274px",
              top: "-150px",
              left: "-112px",
              background: "none",
            }}
          >
            {renderColorBumperDonut(donutBumperData)}
          </div>
        </li> */}
        {/* {Object.keys(cBumper).length > 0 && (
          <li className="color-menu w-full">
            <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
              Bumper
            </a>
            <div
              className="sub-menu"
              style={{
                height: "150px",
                width: "274px",
                top: "-150px",
                left: "-112px",
                background: "none",
              }}
            >
              {renderColorBumperDonut(donutBumperData)}
            </div>
          </li>
        )} */}
        <li className="w-full hidden">
          <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
            Wheels
          </a>
          <div className="sub-menu">
            <ul>
              {!!wheels.length &&
                wheels.map((d, i) => (
                  <li key={i} onClick={(e) => props.updateWheelAction(d)}>
                    {/* {cWheel.name === d.name ? (
                      <>
                        <i
                          className="fas fa-check-circle"
                          style={{ color: "green" }}
                        ></i>{" "}
                      </>
                    ) : (
                      " "
                    )} */}
                    <a href="#" className={cVariant.name === d.name ? 'selected-text' : ''}>{d.name}</a>
                  </li>
                ))}
            </ul>
          </div>
        </li>
        {/* Spoilers */}
        <li className="w-full hidden">
          <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
            Setting
          </a>
          <div className="sub-menu">
            <ul>
              {!!spoilers.length &&
                spoilers.map((d, i) => (
                  <li key={i} onClick={(e) => updateSpoilers(d)}>
                    {/* {isSpoilerActive(d.name) ? (
                      <>
                        <i
                          className="fas fa-check-circle"
                          style={{ color: "green" }}
                        ></i>{" "}
                      </>
                    ) : (
                      " "
                    )} */}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      {d.name}
                    </a>
                  </li>
                ))}
              {!spoilers.length ? <li>No Spoilers</li> : ""}
            </ul>
          </div>
        </li>
        <li className="w-full">
          <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
            Other Options
          </a>
          <div className="sub-menu">
            <ul>
              <li
                onClick={(e) => {
                  e.preventDefault();
                  setIsAllOtherOptionSelected(!isAllOtherOptionSelected);
                  otherOptions.forEach((d) => {
                    updateOtherOptions(d);
                  });
                }}
              >
                {isAllOtherOptionSelected ? (
                  <>
                    <i
                      className="fas fa-check-circle"
                      style={{ color: "green" }}
                    ></i>{" "}
                  </>
                ) : (
                  " "
                )}
                <a href="#">Select All</a>
              </li>
              {!!otherOptions.length &&
                otherOptions.map((d, i) => (
                    <li key={i} onClick={(e) => updateOtherOptions(d)}>
                      <a
                        href="#"
                        className={isOptionActive(d.name) ? 'selected-text' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {d.name}
                      </a>
                    </li>
                ))}
            </ul>
          </div>
        </li>
        <li className="w-full">
          <a className="h-12 md:rounded-lg text-white w-full md:w-12" href="#">
            Variant
          </a>
          <div className="sub-menu list whitespace-normal flex">
            <ul className="text-left grid grid-cols-2">
              <li>
                <div className="text-xs md:text-base font-semibold text-red-500">
                  Grade
                </div>
                <div className="text-xs md:text-base mt-1 text-sm text-gray-800">
                  {cVariant.name}
                </div>
                <div className="text-xs md:text-base font-semibold text-red-500 mt-2">
                  Body Colour
                </div>
                <div className="text-xs md:text-base mt-1 text-sm text-gray-800">
                  {cColor.name}
                </div>
                <div className=" hidden text-xs md:text-base font-semibold text-red-500 mt-2">
                  Wheel Type
                </div>
                <div className="hidden text-xs md:text-base mt-1 text-sm text-gray-800">
                  {cWheel.name}
                </div>
              </li>
              {/* <!-- left --> */}
              <li>
                <div className="text-xs md:text-base font-semibold text-red-500">
                  Option & Accessories
                </div>

                {rareUpperSpoiler ? (
                  <div className="text-xs md:text-base mt-1 text-sm text-gray-800">
                    Rare Spoiler
                  </div>
                ) : (
                  ""
                )}
                {frontSpoiler ? (
                  <div className="text-xs md:text-base mt-1 text-sm text-gray-800">
                    Front Spoiler
                  </div>
                ) : (
                  ""
                )}
                {sideSpoiler ? (
                  <div className="text-xs md:text-base mt-1 text-sm text-gray-800">
                    Side Spoiler
                  </div>
                ) : (
                  ""
                )}
                {!!Object.keys(cOther).length &&
                  Object.keys(cOther).map((d, i) => (
                    <div className="text-xs md:text-base mt-1 text-sm text-gray-800" key={i}>
                      {d}
                    </div>
                  ))}
              </li>
              {/* <!-- right --> */}
            </ul>
          </div>
        </li>
        <li className="w-full">
          <button
            className="focus:outline-none active:outline-none right h-12 px-3 md:px-16 md:rounded-lg text-white bg-black bg-opacity-75 hover:bg-opacity-100 transition ease-in-out duration-300"
            onClick={handleShow}
          >
            Interior
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default connect(null, {
  updateVariantAction,
  updateColorAction,
  updateWheelAction,
  updateRareUpperSpoiler,
  updateRareUnderSpoiler,
  updateSideSpoiler,
  updateFrontSpoiler,
  updateOtherOptions,
  updateSpoilers,
  updateBumperAction,
})(BottomNavigationComponent);
